import React, { Component } from 'react'
import { connect } from 'react-redux'
import { languageSwitchItem } from '../actions/locales'
import { setNeedToShowUserWarning } from '../actions/localStates'

import i18next from 'i18next'

import { bindActionCreators } from 'redux'

import Body from '../components/body/Body'

class BodyContainer extends Component {

	componentDidMount() {
		
	}

	closeWarning () {
		this.props.actions.setNeedToShowUserWarning("false")
	}

	render() {
		return (
			<div className={this.props.baseUrls.fontSize !== 0 ? "visual-impairment-content-font-size-" + this.props.baseUrls.fontSize : null}>
				<Body connectionStatus={this.props.connectionStatus} />
				{
					this.props.baseUrls.needToShowUserWarning === "true" && this.props.baseUrls.bodyIsMounted
					? <div className="user-warning">
						<label className="" style={{marginLeft: "20px", marginTop: "15px", color: "#888888"}}>
							<i class="fa fa-info-circle fa-2x" style={{color: "#999"}} aria-hidden="true"></i>
							<span style={{color: "#888888", fontSize: "18px", fontWeight: "700", marginLeft: "15px"}}>{i18next.t("warning")}</span>
						</label><i class="fa fa-times" style={{
								    position: "absolute",
								    top: "15px",
								    right: "20px",
								    cursor: "pointer",
								    fontSize: "1.3rem"
								  }} onClick={this.closeWarning.bind(this)}></i>
						<ul style={{marginLeft: "36px", paddingRight: "40px"}}>
							<li>{i18next.t("userWarningFirstLine")}</li>
							<li>{i18next.t("userWarningSecondLine")}</li>
							<li>{i18next.t("userWarningThirdLine")}</li>
						</ul>
					  </div>
					: null
				}
			</div>
		);
	}
}

function mapStateToProps(state) {
    return {
        locales: state.i18n,
        baseUrls: state.base,
        localesReducer: state.localesReducer,
        mobileModeReducer: state.mobileModeReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
	    languageSwitchItem,
	    setNeedToShowUserWarning
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(BodyContainer);